import { PureComponent } from 'react';
import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';
import { slice } from 'lodash/fp';
import cns from 'classnames';
import { connect } from 'react-redux';

import Item from './Item';
import mapStateToProps from './mapStateToProps';
import cn from './styles.local.less';

const MAX_FILTERS_TO_SHOW = 7;

class ActiveFiltersList extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    filters: PropTypes.array,
    maxFiltersToShow: PropTypes.number,
    isCollapsible: PropTypes.bool,
    onRemoveAllClick: PropTypes.func,
    onItemRemove: PropTypes.func,
  };

  static defaultProps = {
    filters: [],
    maxFiltersToShow: MAX_FILTERS_TO_SHOW,
    isCollapsible: true,
  };

  state = {
    isCollapsed: true,
  };

  getFilters() {
    const { isCollapsed } = this.state;
    const { filters, maxFiltersToShow } = this.props;

    if (isCollapsed) {
      return slice(0, maxFiltersToShow)(filters);
    }

    return filters;
  }

  handleRemoveAllClick = (e) => {
    const { onRemoveAllClick } = this.props;

    if (onRemoveAllClick) {
      e.preventDefault();

      onRemoveAllClick();
    }
  };

  handleFilterVisibility = () => {
    const { isCollapsed } = this.state;

    this.setState({ isCollapsed: !isCollapsed });
  };

  shouldShowMore() {
    const { isCollapsed } = this.state;
    const { isCollapsible, filters, maxFiltersToShow } = this.props;

    return isCollapsible && isCollapsed && filters.length > maxFiltersToShow;
  }

  shouldShowLess() {
    const { isCollapsed } = this.state;
    const { isCollapsible, filters, maxFiltersToShow } = this.props;

    return isCollapsible && !isCollapsed && filters.length > maxFiltersToShow;
  }

  shouldShowMoreEllipsis() {
    const { isCollapsible, filters, maxFiltersToShow } = this.props;

    return !isCollapsible && filters.length > maxFiltersToShow;
  }

  handleShowLessClick = () => {
    this.setState({ isCollapsed: true });
  };

  handleShowMoreClick = () => {
    this.setState({ isCollapsed: false });
  };

  render() {
    const { className, onItemRemove } = this.props;
    const filters = this.getFilters();

    return filters.length ? (
      <ul
        className={cns(cn.root, className)}
        data-qa-selector="active-filter-list"
      >
        {filters.map(({ form, label, name }, index) => (
          <li className={cn.item} key={index}>
            <Item form={form} onClick={onItemRemove} name={name}>
              {label}
            </Item>
          </li>
        ))}

        {this.shouldShowMoreEllipsis() ? (
          <li className={cn.moreFiltersEllipsis}>...</li>
        ) : null}

        {this.shouldShowMore() ? (
          <li>
            <Button
              bsStyle="link"
              className={cn.showMoreLessFilters}
              onClick={this.handleShowMoreClick}
            >
              {__('search.showMoreFilters')}
            </Button>
          </li>
        ) : null}

        {this.shouldShowLess() ? (
          <li>
            <Button
              bsStyle="link"
              className={cn.showMoreLessFilters}
              onClick={this.handleShowLessClick}
            >
              {__('search.showLessFilters')}
            </Button>
          </li>
        ) : null}

        <li>
          <Button
            data-qa-selector="clear-filters"
            bsStyle="link"
            className={cn.clear}
            onClick={this.handleRemoveAllClick}
          >
            {__('search.clearAll')}
          </Button>
        </li>
      </ul>
    ) : null;
  }
}

export default connect(mapStateToProps)(ActiveFiltersList);
